import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-micro-finalappr-grid',
  templateUrl: './micro-finalappr-grid.component.html',
  styleUrls: ['./micro-finalappr-grid.component.scss']
})
export class MicroFinalapprGridComponent implements OnInit {
public Microsoft360Finaleditdata:any={};
  constructor(public appservice:AppService,public toastr:ToastrService, public router:Router) { }
 editEmployee(id:any){
    //this.appservice.get_Microsoft360_ITfacilityeditdata(id);
    this.appservice.Microsoft360finaleditid=id;
    this.router.navigateByUrl('/home/microsoft-finalapprover');
    
  }
  ngOnInit(): void {
    this.appservice.get_Microsoft360_finalappgrid();
  }


}
